import { Dropdown } from 'semantic-ui-react';
import { useMarketplaceOptions } from 'hooks/useMarkeplaceOptions';

export default function MarketplacesDropdown({
  marketplaces,
  value,
  onAddItem = () => {},
  onLabelClick = () => {},
  onChange = () => {},
  ...props
}) {
  const marketplaceOptions = useMarketplaceOptions(marketplaces);

  return (
    <Dropdown
      placeholder="Marketplace"
      fluid
      multiple
      search
      selection
      noResultsMessage="No hay coincidencias"
      selectOnBlur={false}
      options={marketplaceOptions}
      value={value}
      onAddItem={onAddItem}
      onLabelClick={onLabelClick}
      onChange={onChange}
      {...props}
    />
  );
}
